import type { Provider } from 'react';
import { createContext, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type NonUndefined = {} | null;
type UseContextValue<T> = () => T;

type CreateRequiredContext = <T extends NonUndefined>(displayName: string) => [Provider<T>, UseContextValue<T>];
export const createRequiredContext: CreateRequiredContext = <T extends NonUndefined>(displayName: string) => {
  const Context = createContext<T | undefined>(undefined);
  Context.displayName = displayName;

  const useContextValue: UseContextValue<T> = () => {
    const value = useContext(Context);

    if (value === undefined) {
      throw new ReferenceError(`<${displayName}Provider> was not found in the component tree`);
    }

    return value;
  };

  return [Context.Provider as Provider<T>, useContextValue];
};
